import * as React from 'react'
import { Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { PersonReportItem } from 'src/modules/serasa/serasa.experian.person.types'

export type OcupacaoProps = {
    person: PersonReportItem
}

export default function Ocupacao({ person }: OcupacaoProps) {
    if (
        !person.registration.educationLevelDescription &&
        !person.registration.profession &&
        !person.registration.jobDescription &&
        !person.registration.occupation
    ) {
        return <></>
    }
    return (
        <>
            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Escolaridade" value={person.registration.educationLevelDescription || '-'} xs={3} />
                <GridItem label="Profissão" value={person.registration.profession || '-'} xs={6} />
                <GridItem label="Ocupação" value={person.registration.occupation || '-'} xs={6} />
                <GridItem label="Descrição do trabalho" value={person.registration.jobDescription || '-'} xs={6} />
            </Grid>
        </>
    )
}
